import Notes from "./Notes";
import AudienceData from "./AudienceData";
import DeleteSelectedRows from "./DeleteSelectedRows";
import TextFieldEdit from "./TextFieldEdit";

export default function Modals() {
  return (
    <>
      <Notes />

      <AudienceData />

      <DeleteSelectedRows />

      <TextFieldEdit />
    </>
  );
}
